import React, { Component } from 'react'
// import { CrfContext } from "../../CrfContext"
import axios from "axios"
import { Link } from "react-router-dom"


export class CashAdvanceView extends Component {
    state = {
        showPage1: true,
        showPage2: false,

        showPage1Err: false,
        showPage2Err: false,

        vendorLists: [],
        projectLists: [],

        cocExpenses: [],
        advances: [],
        ppeAccounts: [],
        adminExpenses: [],
        advancesProjectClass: [],

        removal: false,
        target: null
    }

    componentDidMount(){
      // ============================================================================
      // GET COC EXPENSES
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/COC Expenses`,
         headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              // console.log(response.data.data[0].accountName)
                let cocExpenses = []
                for (let i = 0; i < response.data.data.length; i++) {
                    cocExpenses.push(response.data.data[i].accountCode+" "+
                    response.data.data[i].accountName)
                }
                
                this.setState({
                    cocExpenses: cocExpenses
                })
                // console.log(this.state.cocExpenses)
          })
          .catch(error => {
              console.log(error.response)   
            })

      // ======================================================================================
      // GET ADVANCES LIST
      axios({
        method: 'GET',
        url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Advances`,
         headers: {
              'Api-Key':
                '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
              Authorization: `Bearer ${localStorage.token}`
            }
          })
            .then(response => {
              // console.log(response)
                let advances = []
                for (let i = 0; i < response.data.data.length; i++) {
                    advances.push(response.data.data[i].accountCode+" "+
                    response.data.data[i].accountName)
                }
                this.setState({
                    advances: advances
                })
                // console.log(this.state.advances)
              
          })
          .catch(error => {
              // console.log(error.response)   
            })

            // ===============================================================================
              // GET PPE ACCOUNT LIST
              axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/PPE Accounts`,
                 headers: {
                      'Api-Key':
                        '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                      Authorization: `Bearer ${localStorage.token}`
                    }
                  })
                    .then(response => {
                      console.log(response)
                        let ppeAccount = []
                        for (let i = 0; i < response.data.data.length; i++) {
                            ppeAccount.push(response.data.data[i].accountCode+" "+
                            response.data.data[i].accountName)
                        }
                        this.setState({
                            ppeAccounts: ppeAccount
                        })
                  })
                  .catch(error => {
                      // console.log(error.response)   
                    })
        // ========================================================================================
      //  GET ADMIN EXPENSES
       
        axios({
          method: 'GET',
          url: `${process.env.REACT_APP_API_KEY}/api/glAccounts/category/Admin Expenses`,
           headers: {
                'Api-Key':
                  '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                Authorization: `Bearer ${localStorage.token}`
              }
            })
              .then(response => {
                // console.log(response)
                let adminExpenses = []
                    for (let i = 0; i < response.data.data.length; i++) {
                      adminExpenses.push(response.data.data[i].accountCode+" "+
                      response.data.data[i].accountName)
                    }
                    this.setState({
                      adminExpenses: adminExpenses
                    })
            })
            .catch(error => {
                // console.log(error.response)   
              })
//=========================================================================================


axios({
  method: 'GET',
  url: `${process.env.REACT_APP_API_KEY}/api/projectClasses`,
  headers: {
    'Api-Key':
      '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
    Authorization: `Bearer ${localStorage.token}`
  }
})
  .then(response => {
    console.log(response)
    this.setState({
      advancesProjectClass: response.data.data
    })
    console.log(this.state.advancesProjectClass)
    
})
.catch(error => {
    console.log(error.response)   
  })
          
// =========================================================================================
              axios({
                method: 'GET',
                url: `${process.env.REACT_APP_API_KEY}/api/itemNo`,
                headers: {
                  'Api-Key':
                    '2fd656df11329944f7e5f3be21a48f401fdcd8ec7ff39526d725cc92edebc130',
                  Authorization: `Bearer ${localStorage.token}`
                }
              })
                .then(response => {
                  // document.getElementById('main').style.display = 'block'
                  console.log(response)
              })
              .catch(error => {
                  console.log(error.response)   
                })
    }

    handleShowPage2 = (e) => {
        
        e.preventDefault()
       if(this.props.vendorErr + this.props.particularsErr + this.props.projectErr
         + this.props.fileErr === 0){
          document.getElementById("page1").style.display = "none"
          document.getElementById("nextButton").style.display = "none"
          document.getElementById("page2").style.display = "block"
          document.getElementById("formPrevBtn").style.display = "block"
          document.getElementById("totalComputation").style.display = "flex"
          document.getElementById("submitButtonDiv").style.display = "block"
         }else{
          this.setState({showPage1Err: true})
         }
    }

    handleShowPage1 = (e) => {
        e.preventDefault()
        document.getElementById("page1").style.display = "block"
        document.getElementById("nextButton").style.display = "block"
        document.getElementById("page2").style.display = "none"
        document.getElementById("formPrevBtn").style.display = "none"
        document.getElementById("totalComputation").style.display = "none"
        document.getElementById("submitButtonDiv").style.display = "none"
    }

    handleRemoveProjectClass = (e) => {
      console.log(e.target)
      console.log(e.target.name)
      this.props.projectClass.splice(parseInt(e.target.id), 1)
      this.setState({
        target: parseInt(e.target.name),
        removal: true
      })
    }


    render() {
        // console.log(this.props.particularsError)
        let projectClassList = []
        for (let key in this.props.projectClass) {
        projectClassList.push(key)
        }

        let particularsEmptyChecker = ""
        if(this.props.particularsError === true){
          particularsEmptyChecker = <>
            {this.props.particulars === "" ? 
                  <small style={errorChecker}>This field can't be empty</small> : 
            null}
          </>
        }

        let vendorEmptyChecker = ""
        if(this.props.vendorError === true){
          vendorEmptyChecker = <>
            {this.props.vendor === "" ? 
                          <small style={errorChecker}>This field can't be empty</small> : 
                        null}
          </>
        }

        let projectEmptyChecker = ""
        if(this.props.projectError === true){
          projectEmptyChecker = <>
            {this.props.project === "" ? 
                          <small style={errorChecker}>This field can't be empty</small> : 
                        null}
          </>
        }

        let   fileEmptyChecker = ""
        if(this.props.supportingDocumentError === true){
          projectEmptyChecker = <>
            {this.props.file === null ? 
                          <small style={errorChecker}>Please upload A file</small> : 
                        null}
          </>
        }


        if(this.state.removal === true){
          projectClassList.splice(this.state.target, 1)
          console.log("test")
          projectClassList = this.props.projectClass
          // this.props.projectClass = projectClassList
          // this.props.projectClass.splice(this.state.target, 1)
        }

        return (
            <>
                <div className="formContent">
                    <div className="formNavigationBtn">
                        <div className="formNavContent">
                            <div id="formPrevBtn" className="formNav1">
                                <button type="button" onClick={this.handleShowPage1}>
                                    <i class="fas fa-arrow-alt-circle-left"></i>
                                </button>
                            </div>
                            
                        </div>
                    </div>
                    
                {/* PAGE 1 */}

                <form onSubmit={this.props.handleSubmitNonPo}>
                    <div className="saveAndCancelButton">
                      <div className="saveAndCancelButtonContent">
                        <button id="saveAsDrafBtn" type="button" onClick={this.props.handleDraftNonPo}>SAVE</button>
                        <Link to="/RequestSelection">
                        <button id="cancelRequestBtn" type="button">
                          CANCEL
                        </button>
                        </Link>
                      </div>
                    </div>
                    <div className="page1" id="page1">
                {/* VENDOR INPUT*/}
                    <p className="label1">
                                Vendor/Payee:
                            <span  id="vendorEmptyError"
                             className="errorChecker">*</span>
                    </p>
                        <input type="text" className="input1NonPo" list="vendorListOptions"
                                name="vendor"
                                id="vendorInput"
                                onChange={this.props.handleChangeRequestField}
                                placeholder="Required"
                        />

                        <datalist id="vendorListOptions">
                            {this.props.vendorLists.map(data => <option className="vendorListData"
                             value={data}/>)}
                        </datalist>

                        
                        <div>
                          <small style={errorChecker}>
                          </small>
                          <small>
                          </small>
                        </div>
                        {vendorEmptyChecker}
                    {/* END OF VENDOR INPUT */}

                    {/* REQUESTING DEPARTMENT INPUT*/}
                    <p className="label1">
                                Requesting Department:
                            <span  id="particularsEmptyError"
                             className="errorChecker">*</span>
                    </p>
                        <select type="text" className="input1NonPoNew"
                                id="departmentInput"
                                name="requestingDepartment"
                                onChange={this.props.handleChangeRequestField}
                                autoComplete="off"
                                placeholder="Required"
                        >
                          <option value="" disabled selected hidden>Please Choose...</option>
                          {(this.props.userDeptList.filter(list => list.isApproved === true)).map(depts => <option value={depts.centerName}>{depts.centerName}</option>)}
                                {/* {this.props.accountTypes.map(data => <option value={data}>{data}</option>  */}
                        </select>
                    {/* END OF REQUESTING DEPARTMENT INPUT */}

                    {/* PARTICULARS INPUT*/}
                    <p className="label1">
                                Particulars:
                            <span  id="particularsEmptyError"
                             className="errorChecker">*</span>
                    </p>
                        <input type="text" className="input1NonPo"
                                id="particularsInput"
                                name="particulars"
                                onChange={this.props.handleChangeRequestField}
                                autoComplete="off"
                                placeholder="Required"
                        />
                        {particularsEmptyChecker}
                    {/* END OF PARTICULARS INPUT */}

                     {/* PROJECT INPUT*/}
                     <p className="label1">
                               Project:
                            <span  id="projectEmptyError"
                             className="errorChecker">*</span>
                    </p>
                        <input type="text" className="input1NonPo" 
                                list="projectDataLists"
                                id="projectInput"
                                name="project"
                                onChange={this.props.handleChangeRequestField}
                                placeholder="Required"
                        />
                     
                        <datalist id="projectDataLists">
                            {this.props.projectLists.map(data => <option value={data}/>)}
                        </datalist>

                        <div>
                          <small style={errorChecker}>
                          </small>
                          <small>
                          </small>
                        </div>

                        {projectEmptyChecker}
                    {/* END OF PROJECT INPUT */}

                     {/* SUBPROJECT INPUT*/}
                     <p className="label1">
                                Sub Project:
                            <span  id="subProjectEmptyError"
                             className="errorChecker"></span>
                    </p>
                        <input type="text" className="input1NonPo"
                                name="subProject"
                                onChange={this.props.handleChangeRequestField}
                                placeholder="Optional"
                                autoComplete="off"
                        />
                    {/* END OF SUBPROJECT INPUT */}

                     {/* SUPPORTING DOCUMENTS INPUT*/}
                     <p className="label1">
                                Supporting Documents:
                            <span  id="documentEmptyError"
                             className="errorChecker">*</span>
                    </p>
                     <div className="fileInputContainer">
                       <div className="uploadedFile">
                         {fileEmptyChecker}
                          {this.props.file !== null ?
                            <>
                             <h1 className="fileIcon">
                             <i class="far fa-file-pdf"></i>
                            </h1>
                             <span>
                            {this.props.file === undefined ? "Please Upload a file..." : this.props.file.name} 
                            </span> 
                            </>
                         : null }
                       </div>

                       <label htmlFor="documentsInput"
                              className="fileLabel">
                         {this.props.file ? "Change File" : "Upload File"}
                        </label>
                       <input 
                              style={displayNone}
                              type="file" id="documentsInput"
                              name="file" accept=".pdf"
                              onChange={this.props.handleChangeRequestField}/>
                     </div>
                    
                        
                    {/* END OF SUPPORTING DOCUMENTS INPUT */}
                    </div>
                    {/* END OF PAGE 1 */}
                    {/* PAGE 2 */}
                    <div className="page2" id="page2">

{/* ===================================================================================================================== */}

                    {projectClassList.map((data, index) => 
                        <div className="projectClassContainer" key={"projectClassContainer"+ index}>
                            <div className="closeButtonContainer">
                             <h3>{parseInt(data) + 1}</h3>
                                {/* <span>
                                    <i class="fas fa-compress-arrows-alt"></i>                                 
                                </span> */}
                                {/* <button type="button" className="removeProjClassBtn"
                                        onClickCapture={this.handleRemoveProjectClass}
                                        name={index}>
                                       &times;
                                </button> */}
                            </div>
                        {/* GL CATEGORY INPUT */}
                            <p className="label2">GL Category
                                <span style={errorChecker} className="projectClassEmptyError">*</span>
                            </p>
                            <select className="glCategoryClass" name="glCategory"
                                    id={index}
                                    onChange={this.props.handleChangeProjectClassValue}
                            >
                                <option className="glCategoryInitialValue" value="" selected hidden>Please Choose...</option>
                                {this.props.accountTypes.map(data => <option value={data}>{data}</option>                                         
                                                      )} 
                            </select>
                        {/*END OF GL CATEGORY INPUT */}
                        {/* GL CATEGORY NAME */}
                        <p className="label2">Account Code/Account Name
                                <span style={errorChecker} className="projectClassEmptyError">*</span>
                            </p>
                            <input  className="glNameClass"
                                    type="text"
                                    name="glAccount"
                                    id={index}
                                    list="accountName"
                                    autoComplete="off"
                                    placeholder="Required"
                                    onChange={this.props.handleChangeProjectClassValue}
                        />

                         {/* PROJECT CLASS */}
                         <p className="label2ProjectClass">Project Class
                                <span style={errorChecker} className="projectClassEmptyError">*</span>
                            </p>
                            <input  className="glNameClassProjectClass"
                                    type="text"
                                    name="projectClass"
                                    id={index}
                                    list="advancesList"
                                    autoComplete="off"
                                    placeholder="Required"
                                    onChange={this.props.handleChangeProjectClassValue}
                            />
                                    <datalist id="advancesList">
                                        {this.state.advancesProjectClass.map(data=> <option value={data}/> )}
                                    </datalist>
                        
                        {/* ITEM NUMBER AND QUANTITY */}
                        {/* <div className="quantityAndItemNumber">
                            <div className="inputContainer1">
                                <p className="label3">Item No.:
                                    <span style={errorChecker} className="projectClassEmptyError">*</span>
                                </p>
                                <input className="input3" type="text"
                                        id={index}
                                        name="itemNumber" 
                                        onChange={this.props.handleChangeProjectClassValue}/>
                            </div>
                            <div className="inputContainer2">
                                <p className="label4">Quantity:
                                    <span style={errorChecker} className="projectClassEmptyError">*</span>
                                </p>
                                <input className="input4" type="number"
                                        id={index}
                                        name="quantity"    
                                        onChange={this.props.handleChangeProjectClassValue}
                                />
                            </div>
                        </div> */}


                         {/* DESCRIPTION 1 */}
                         <p className="label2">Description 1
                                <span style={errorChecker} className="projectClassEmptyError">*</span>
                            </p>
                            <input  className="description1Class"
                                    type="text"
                                    name="description1"
                                    id={index}
                                    autoComplete="off"
                                    placeholder="Required"
                                    onChange={this.props.handleChangeProjectClassValue}
                            />

                        {/* DESCRIPTION  2*/}
                        <p className="label2">Description 2
                                <span style={errorChecker} className="projectClassEmptyError"></span>
                            </p>
                            <input  className="description2Class"
                                    type="text"
                                    name="description2"
                                    id={index}
                                    autoComplete="off"
                                    placeholder="Optional"
                                    onChange={this.props.handleChangeProjectClassValue}
                            />

                        {/* Gross Price  */}
                        <p className="label2">Gross Price:
                                <span style={errorChecker} className="projectClassEmptyError">*</span>
                            </p>
                            <input  className="description2Class"
                                    min="0.01"
                                    step="any"
                                    type="number"
                                    name="grossPricePerItem"
                                    id={index}
                                    autoComplete="off"
                                    placeholder="Required"
                                    onChange={this.props.handleChangeProjectClassValue}
                            />

                             {/* VAT TYPE AND WITHHOLDING TAX */}
                        <div className="quantityAndItemNumber">
                            <div className="inputContainer1">
                                <p className="label3">Vat Type.:
                                    <span style={errorChecker} className="projectClassEmptyError">*</span>
                                </p>
                                {/* <input className="input5" type="text"/> */}
                                <select 
                                    className="input5"
                                    id={index}
                                    type="number"
                                    name="vatType"
                                    placeholder="Required"
                                    onChange={this.props.handleChangeProjectClassValue}>
                                    {this.props.vatTypeSelections}
                                </select>
                            </div>
                            <div className="inputContainer2">
                                <p className="label3">Withholding Tax:
                                    <span style={errorChecker} className="projectClassEmptyError">*</span>
                                </p>
                                {/* <input className="input6" type="text"/>/ */}
                                <select 
                                    className="input6"
                                    id={index}
                                    type="number"
                                    name="wTaxType"
                                    onChange={this.props.handleChangeProjectClassValue}>
                                        <option value="" disabled selected hidden>Please Choose...</option>
                                            {this.props.wTaxRates.map(data => 
                                        <option value={data.wTaxCode}>{data.wTaxCode === "X1" ?  "None (X1)": data.wTaxDisplayName + " " + data.wTaxCode}</option>
                                            )}
                                        {/* <option value="X1">None (X1)</option> */}
                                        </select> 
                            </div>
                        </div>
                        <div className="subComputationContainer">
                            <div className="subComputation1">
                                <p>Sub Total Gross Price</p>
                                <p>Sub Total Net Price</p>
                            </div>
                            <div className="subComputation2">
                                <div className="subComputations">
                                    <span><h4 style={padding1}>&#8369;</h4><h4 className="subTotalGrossPrice"></h4></span>
                                    <span><h4 style={padding1}>&#8369;</h4><h4 className="subTotalNetPrice"></h4></span>
                                </div>
                            </div>
                        </div>

                            {/* COC EXPENSES LIST */}
                            <datalist id="cocExpenses">
                                    {this.state.cocExpenses.map(data=> <option value={data}/> )}
                            </datalist>
                            {/* ADVANCES LIST */}
                            <datalist id="advances">
                                    {this.state.advances.map(data=> <option value={data}/> )}
                            </datalist>
                            {/* PPE ACCOUNTS LIST */}
                            <datalist id="ppeAccounts">
                                    {this.state.ppeAccounts.map(data=> <option value={data}/> )}
                            </datalist>
                            {/* Admin Expenses */}
                            <datalist id="adminExpenses">
                                    {this.state.adminExpenses.map(data=> <option value={data}/> )}
                            </datalist>
                        {/*END OF GL CATEGORY NAME */}
                        </div>
                        )}
{/* ======================================================================================================== */}
                {/*END OF PAGE 2 */}
                </div>
                <div id="totalComputation" className="totalComputation">
                    <div className="computationDesc">
                        <h4>Requesting Gross Price:</h4>
                        <h4>Requesting Amount:</h4>
                    </div>
                    <div className="computations">
                        <span><h4 style={padding1}>&#8369;</h4><h4 id="requestingGrossPrice"></h4></span>
                        <span><h4 style={padding1}>&#8369;</h4><h4 id="requestingAmount"></h4></span>
                    </div>
                    <div className="addProjectClassBtnContainer">
                        <h5 onClick={this.props.addProjectClass}>Add Project Class</h5>
                    </div>
                </div>
                    
                  <div className="formHintContainer" id="formHintContainer">
                    <i id="validationHintIcon" class="fas fa-exclamation-triangle"></i>
                    <span>
                    Error:
                    </span>
                    <span id="errorHint">
                                      
                    </span>
                  </div>

                    <div id="submitButtonDiv" className="submitButtonDiv">
                        <button id="submitButton" type="submit" >Submit</button>
                    </div>
                    </form>
            
                    <div id="nextButton" className="nextButton">
                        <button onClick={this.handleShowPage2}>NEXT</button>
                    </div>

                    {/* <button onClick={this.props.checkStateValue}>Check State</button> */}
                </div>
            </>
        )
    }
}

const errorChecker = {
    color: "red",
    fontFamily: "Calibri",
    fontSize: "15px"
}
const padding1 = {
    paddingRight: "5px"
}

const displayNone = {
    display: 'none'
}

export default CashAdvanceView
